/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Student10Inputs */

const en__field_enum_mzs_student10 = /** @type {(inputs: _Field_Enum_Mzs_Student10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`students`)
};

const de__field_enum_mzs_student10 = /** @type {(inputs: _Field_Enum_Mzs_Student10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studierende`)
};

/**
* | output |
* | --- |
* | "students" |
*
* @param {_Field_Enum_Mzs_Student10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_student10 = /** @type {((inputs?: _Field_Enum_Mzs_Student10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Student10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_student10(inputs)
	return de__field_enum_mzs_student10(inputs)
});
export { _field_enum_mzs_student10 as "_field_enum_MZS_STUDENT" }